import { Suspense } from "react";
import { createBrowserRouter, Navigate } from "react-router";
import ErrorScreen from "./components/ErrorScreen";
import Layout from "./components/Layout";
import { lazyWithRetry } from "./utils/lazyWithRetry";

const CalendarPage = lazyWithRetry(() => import("./pages/Calendar"));
const ItemsPage = lazyWithRetry(() => import("./pages/Items"));
const AddonsPage = lazyWithRetry(() => import("./pages/Addons"));
const InfoPage = lazyWithRetry(() => import("./pages/Info"));
const OrderConfirmation = lazyWithRetry(() => import("./pages/OrderConfirmation"));

function SuspenseWrapper({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={null}>{children}</Suspense>;
}

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorScreen />,
    children: [
      {
        path: "/",
        element: (
          <SuspenseWrapper>
            <CalendarPage />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/items/:step",
        element: (
          <SuspenseWrapper>
            <ItemsPage />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/addons/:step",
        element: (
          <SuspenseWrapper>
            <AddonsPage />
          </SuspenseWrapper>
        ),
      },
      {
        path: "/gegevens",
        element: (
          <SuspenseWrapper>
            <InfoPage />
          </SuspenseWrapper>
        ),
      },
    ],
  },
  {
    path: "/flow/success",
    element: (
      <SuspenseWrapper>
        <OrderConfirmation />
      </SuspenseWrapper>
    ),
    errorElement: <ErrorScreen />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);
